module.exports = __webpack_public_path__ + "static/media/dollar-yellow.9dc45c47.svg";